import { call, put } from 'redux-saga/effects'
import { baseFetchToken } from './BaseSaga'
import OrderActions from '../Redux/OrderRedux'
import AuthActions from '../Redux/AuthRedux'
import { getToken } from '../Services/GetToken'

export function * getOrder (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getOrder, token, action.filter)
      if (!res.ok) {
        yield put(OrderActions.orderFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const data_with_page = {
            data: res.data.data,
            page,
            total
          }
          yield put(OrderActions.orderSuccess(data_with_page))
        } else {
          yield put(OrderActions.orderFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(OrderActions.orderFailure())
  }
}

export function * getOrderSingle (api, action) {
  yield baseFetchToken(api.getOrderSingle,
    action.id,
    getToken,
    OrderActions.orderSingleSuccess,
    OrderActions.orderSingleFailure)
}

export function * updateOrder (api, action) {
  yield baseFetchToken(api.updateOrder,
    action.data,
    getToken,
    OrderActions.orderUpdateSuccess,
    OrderActions.orderUpdateFailure)
}

export function * updateCheckoutOrder (api, action) {
  yield baseFetchToken(
    api.updateCheckoutOrder,
    action.data,
    getToken,
    OrderActions.orderCheckoutSuccess,
    OrderActions.orderCheckoutFailure
  )
}

export function * updateOrderAmount (api, action) {
  yield baseFetchToken(api.updateOrderAmount,
    action.data,
    getToken,
    OrderActions.orderUpdateAmountSuccess,
    OrderActions.orderUpdateAmountFailure)
}

export function * getOrderDetailList (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getOrderDetailList, token, action.filter)
      if (!res.ok) {
        yield put(OrderActions.orderDetailListFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const data_with_page = {
            data: res.data.data,
            page,
            total
          }
          yield put(OrderActions.orderDetailListSuccess(data_with_page))
        } else {
          yield put(OrderActions.orderDetailListFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(OrderActions.orderDetailListFailure())
  }
}

export function * confirmOrder (api, action) {
  yield baseFetchToken(api.confirmOrder,
    action.data,
    getToken,
    OrderActions.orderConfirmSuccess,
    OrderActions.orderConfirmFailure)
}

export function * orderListSpreadsheet (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.orderListSpreadsheet, token, action.filter)
      if (!res.ok) {
        yield put(OrderActions.orderListDownloadFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(OrderActions.orderListDownloadSuccess(res.data))
        } else {
          yield put(OrderActions.orderListDownloadFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(OrderActions.orderListDownloadFailure())
  }
}

export function * orderDetailListSpreadsheet (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.orderDetailListSpreadsheet, token, action.filter)
      if (!res.ok) {
        yield put(OrderActions.orderDetailListDownloadFailure('Terjadi kesalahan, ulangi beberapa saat lagi'))
      } else {
        if (!res.data.error) {
          yield put(OrderActions.orderDetailListDownloadSuccess(res.data))
        } else {
          yield put(OrderActions.orderDetailListDownloadFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(OrderActions.orderDetailListDownloadFailure())
  }
}

export function * downloadOrderInvoice (api, action) {
  yield baseFetchToken(api.downloadOrderInvoice,
    action.data,
    getToken,
    OrderActions.orderInvoiceSuccess,
    OrderActions.orderInvoiceFailure)
}

export function * resendOrderVoucher (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.resendOrderVoucher, token, action.data)
      if (!res.ok) {
        yield put(OrderActions.resendOrderVoucherFailure('Failed'))
      } else {
        if (!res.data.erorr) {
          yield put(OrderActions.resendOrderVoucherSuccess(res.data))
        } else {
          yield put(OrderActions.resendOrderVoucherFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(OrderActions.resendOrderVoucherFailure())
  }
}

export function * getOrderReport (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getOrderReport, token, action.filter)
      if (!res.ok) {
        yield put(OrderActions.getOrderReportFailure('Terjadi kesalahan'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let data = res.data.data
          let total = res.data.meta.count
          let metaTravypass = res.data.meta.metaTravypass
          let stat_modem_passpod = res.data.meta.metaTravypass.stat_modem_passpod
          const DATA_APPEND = {
            data,
            page,
            total,
            metaTravypass,
            stat_modem_passpod
          }
          yield put(OrderActions.getOrderReportSuccess(DATA_APPEND))
        } else {
          yield put(OrderActions.getOrderReportFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(OrderActions.getOrderReportFailure())
  }
}

export function * getOrderReportSpreadsheet (api, action) {
  yield baseFetchToken(
    api.getOrderReportSpreadsheet,
    action.filter,
    getToken,
    OrderActions.getOrderReportSpreadsheetSuccess,
    OrderActions.getOrderReportSpreadsheetFailure
  )
}

export function * getChatbotOrder (api, action) {
  try {
    const token = yield call(getToken)
    if (!token) {
      yield put(AuthActions.authLogout())
    } else {
      const res = yield call(api.getChatbotOrder, token, action.filter)
      if (!res.ok) {
        yield put(OrderActions.getChatbotOrderFailure('ERR_MSG_CHB_ORDER_FAILURE'))
      } else {
        if (!res.data.error) {
          let page = parseInt(res.data.meta.page, 10)
          let total = res.data.meta.count
          const DATA_WITH_PAGE = {
            data: res.data.data,
            page,
            total
          }
          yield put(OrderActions.getChatbotOrderSuccess(DATA_WITH_PAGE))
        } else {
          yield put(OrderActions.getChatbotOrderFailure(res.data.message))
        }
      }
    }
  } catch (e) {
    yield put(OrderActions.getChatbotOrderFailure())
  }
}

export function * postChatbotOrder (api, action) {
  yield baseFetchToken(
    api.postChatbotOrder,
    action.data,
    getToken,
    OrderActions.postChatbotOrderSuccess,
    OrderActions.postChatbotOrderFailure
  )
}

export function * refundDana (api, action) {
  yield baseFetchToken(
    api.refundDana,
    action.data,
    getToken,
    OrderActions.refundDanaSuccess,
    OrderActions.refundDanaFailure
  )
}



// WEBPACK FOOTER //
// ./src/Sagas/OrderSagas.js